export const REDUCER_NAME = 'customer'
export const CUSTOMER_COMPUTED_BID_LIMIT = 'customerComputedBidLimit'
export const IS_LOADING_CUSTOMER_COMPUTED_BID_LIMIT = 'isLoadingCustomerComputedBidLimit'

export const SET_IS_LOADING_CUSTOMER_COMPUTED_BID_LIMIT = 'SET_IS_LOADING_CUSTOMER_COMPUTED_BID_LIMIT'
export const SET_CUSTOMER_COMPUTED_BID_LIMIT = 'SET_CUSTOMER_COMPUTED_BID_LIMIT'
